/**
 * LocaleSelector.tsx — Language picker dropdown.
 * Sprint 10.3: i18n locale selection UI.
 *
 * Renders a compact dropdown showing the current language code.
 * Persists selection to localStorage via i18next detection config.
 */
import { useTranslation } from 'react-i18next';
import { supportedLanguages } from '../../i18n';

export function LocaleSelector({ className }: { className?: string }) {
  const { i18n } = useTranslation();

  const currentLang = supportedLanguages.find(
    (l) => i18n.language.startsWith(l.code)
  ) ?? supportedLanguages[0];

  return (
    <select
      value={currentLang.code}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      className={`locale-selector ${className ?? ''}`}
      aria-label="Select language"
      style={{
        background: 'transparent',
        border: '1px solid var(--color-border)',
        borderRadius: '4px',
        padding: '4px 8px',
        fontSize: '13px',
        color: 'var(--color-text-secondary)',
        cursor: 'pointer',
      }}
    >
      {supportedLanguages.map((lang) => (
        <option key={lang.code} value={lang.code}>
          {lang.label}
        </option>
      ))}
    </select>
  );
}
